import { apiSlice } from '../api/apiSlice'
import { AuditLogsResponse, QueryPropsLogs } from './auditLogs.types'

export const auditLogsApiSlice = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getAllAuditLogs: builder.query<AuditLogsResponse, QueryPropsLogs>({
      query: (params) => {
        return {
          url: `v1/audit-logs`,
          method: 'GET',
          params: {
            ...params,
            isAdmin: true,
          },
        }
      },
      providesTags: [{ type: 'AUDIT_LOG', id: 'LIST' }],
    }),
  }),
})

export const { useGetAllAuditLogsQuery, useLazyGetAllAuditLogsQuery } =
  auditLogsApiSlice
